import {
  ConditionalRenderer,
  ConfirmationApprovedModal,
  ConfirmationRejectModal,
  ErrorModal,
} from "../../../../../components";
import { statusCode } from "../../../../../utils/constants";

function ConfirmationDialogs({
  text,
  viewPath,
  isOpen,
  onClickHandler,
  setIsOpen,
  rejectReason,
  setRejectReason,
  isError,
  setIsError,
}: any) {
  function handleClose() {
    setIsOpen({ status: false, currId: null, module: "" });
  }

  function onErrorModalClose() {
    setIsError(false);
  }

  if (isError) {
    return <ErrorModal isOpen={isError} handleClose={onErrorModalClose} />;
  }
  return (
    <>
      <ConditionalRenderer
        condition={isOpen?.moduleCode === statusCode.approved}
      >
        <ConfirmationApprovedModal
          isOpen={isOpen?.status}
          handleClose={handleClose}
          text={text}
          onClickHandler={onClickHandler}
          viewPath={viewPath}
          item={isOpen?.currId}
        />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={isOpen?.moduleCode === statusCode.rejected}
      >
        <ConfirmationRejectModal
          text={text}
          onClickHandler={onClickHandler}
          item={isOpen?.currId}
          viewPath={viewPath}
          isOpen={isOpen?.status}
          handleClose={handleClose}
          value={rejectReason}
          setValue={setRejectReason}
        />
      </ConditionalRenderer>
    </>
  );
}

export { ConfirmationDialogs };
